/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

AjaxTags.js - fetch array of tag objects and fill the DOM on `/tags`


*/

// Run the Things
document.addEventListener('DOMContentLoaded', () => {
  // Fetch tags data
  const getTagsAJAX = async (sortorder) => {
    const url = `/tag-objects/${sortorder}`;
    const tagsArrays = await fetch(url)
      .then((response) => response.text())
      .then((data) => {
        return data;
      });

    return JSON.parse(tagsArrays);
  };

  // Toggle visibility of loader & tagslist
  const toggleTagsContent = (loaded) => {
    const loader = document.querySelector('.embedded-loader-parent');
    const tagsList = document.querySelector('#tags-list');

    if (loaded) {
      loader.style.display = 'none';
      tagsList.style.display = 'block';
    } else {
      loader.style.display = 'grid';
      tagsList.style.display = 'none';
    }
  };

  // Populate DOM
  const loadTags = async (sortorder) => {
    const fetched_tags = await getTagsAJAX(sortorder);
    const listEl = document.querySelector('#tags-list');
    const tagCount = fetched_tags.length;
    const tagCountEl = document.querySelector('#tag-count');

    if (fetched_tags.length === 0) {
      window.location.href = '/help/using-tags';
    }

    // Safari barfs unless some DOM-dependent value
    // is accessed in a function call at precisely this
    // point in the code; Safari is weird.

    // If you see this later, try deleting the wrapping anon function
    // and see if anythings breaks in Safari.
    (() => {
      listEl.innerHTML = '';
    })();
    // End stupid Safari-coddling

    for (let obj of fetched_tags) {
      const tag = `
				<li>
					<span class="tag">
						<a href="/tag/${obj.tag}">${obj.tag}</a> 
						<span class="count">(${obj.instance_count})</span>
					</span>
				</li>
			`;
      listEl.insertAdjacentHTML('beforeEnd', tag);
    }
    tagCountEl.innerHTML = `${tagCount}`;
    toggleTagsContent(true);
  };

  if (document.querySelector('#tags-list')) {
    const queryString = window.location.search;
    const sortLinks = document.querySelectorAll('#context-nav-items a');
    let sortorder = 'descending';

    if (queryString.length > 0) {
      sortorder = queryString.split('?sortorder=')[1];
    }

    loadTags(sortorder);

    for (let link of sortLinks) {
      link.addEventListener('click', (event) => {
        toggleTagsContent((loaded = false));
        event.preventDefault();

        const url = window.location.href;
        const sortorder = event.target.dataset.sortorder;

        loadTags(sortorder);
        history.replaceState(
          null,
          '',
          `${url.split('?')[0]}?sortorder=${sortorder}`
        );
      });
    }
  }
});
